import { LazyLoad } from '@petconsole/pure-fe-mui';

const LazyLoaded = LazyLoad(() => import('./Notifications'));

export { LazyLoaded as Notifications };
